import Couteau_formation from './images/Couteua-formation.png'
import OutilsFormation from './Outils-formation'

export default function couteau_formation() {
    const SolutionFormation = (
        <>
            <div className='content-solution'>
                <div className='solution-titre'>FORMATION</div>
                <div className='solution-img-container'><img className='image-solution' src={Couteau_formation} /></div>
            </div>
            <div className='outil-1'>
                <div className='solution-body-formation'>
                    <OutilsFormation />
                </div>
            </div>
        </>
    );
    return SolutionFormation
}